/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Registration_Contactfirstname_Label2Inputs */

const en_company_registration_contactfirstname_label2 = /** @type {(inputs: Company_Registration_Contactfirstname_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact First Name`)
};

const de_company_registration_contactfirstname_label2 = /** @type {(inputs: Company_Registration_Contactfirstname_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorname der Kontaktperson`)
};

/**
* | output |
* | --- |
* | "Contact First Name" |
*
* @param {Company_Registration_Contactfirstname_Label2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const company_registration_contactfirstname_label2 = /** @type {((inputs?: Company_Registration_Contactfirstname_Label2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Registration_Contactfirstname_Label2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_registration_contactfirstname_label2(inputs)
	return en_company_registration_contactfirstname_label2(inputs)
});
export { company_registration_contactfirstname_label2 as "company_registration_contactFirstName_label" }